import url from './url';



export default url(({ newsId = ':newsId' }) => `/news/${newsId}/edit`);
